module.exports = __webpack_public_path__ + "assets/ziyuan_16.1e32d421.svg";